package editor.structure

import common.dto.Direction
import common.dto.ElementType
import common.dto.Quat
import common.dto.Vec3d
import ext.asEuler
import ext.asQuat
import ext.set
import kotlinx.serialization.Serializable
import three.js.Quaternion

/**
 * An element in a structure that can be loaded into the editor.
 *
 * When placing a new element, the position and rotation is calculated based on the base element
 * that the new one is placed onto. While in the placing state, the user can modify the offset
 * by moving the mouse on an imagined 2D plane placed on the surface of the base element.
 */
@Serializable
data class StructureElement(
    val type: ElementType,
    val pos: Vec3d = Vec3d(),
    val rot: Quat = Quat(),
) {
    constructor(type: ElementType, pos: Vec3d, direction: Direction) : this(type, pos, direction.quaternion)
    constructor(type: ElementType, pos: Vec3d, euler: Vec3d) : this(type, pos, Quaternion().setFromEuler(euler.asEuler()).asQuat())

    val object3D by lazy {
        type.cloneModel().apply {
            position.set(pos)
            quaternion.set(rot)
        }
    }
}